import { useFeatureFlags } from '@brightdrop/feature-flags-client';
import { useTranslation } from 'react-i18next';

import { AlertMessage } from '~/common/components';
import { ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG } from '~/common/models/featureFlags.model';

const MOBILE_APP_BRAND_NAME_LEGACY = 'GM';
const MOBILE_APP_BRAND_NAME_REBRAND = 'OnStar';

const MobileAppRequiredAlert = (): JSX.Element => {
  const { t } = useTranslation('common');
  const { getFlag } = useFeatureFlags();
  const brandName = getFlag(ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG)
    ? MOBILE_APP_BRAND_NAME_REBRAND
    : MOBILE_APP_BRAND_NAME_LEGACY;

  return (
    <AlertMessage
      header={t('alertMsg.messageView.mobileAppRequired.header')}
      body={t('alertMsg.messageView.mobileAppRequired.body', { brandName })}
      showGraphic
      topic="mobileAppRequired"
      id="mobile-app-required"
      wrapperClassName={
        getFlag(ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG)
          ? 'mobileAppRequiredRebrand'
          : undefined
      }
    />
  );
};

export default MobileAppRequiredAlert;
